import { observable, watch } from "@chorda/core";
import { Field, MediaLayout } from "chorda-bulma";
import { Nasa } from "../../api";
import { withList } from "../../utils";
import { BgImage, TextInput } from "../../helpers";
import _ from "lodash";
export const Images = () => {
    return {
        templates: {
            form: {
                templates: {
                    search: Field({
                        control: TextInput({
                            placeholder: 'Search text',
                            value$: $ => $.query,
                        })
                    })
                }
            },
            result: {
                templates: {
                    list: withList({
                        styles: {
                            maxHeight: 460,
                            overflow: 'auto',
                        },
                        injections: {
                            items: $ => $.collection.items
                        },
                        defaultItem: MediaLayout({
                            templates: {
                                content: BgImage({
                                    url$: $ => $.item.links[0].href,
                                    as: {
                                        css: 'search-preview'
                                    }
                                }),
                            }
                        }),
                        // defaultItem: {
                        //     reactions: {
                        //         item: v => patch({text: JSON.stringify(v)})
                        //     }
                        // }
                    })
                }
            }
        },
        defaults: {
            query: () => observable('soyuz'),
            collection: () => observable(null),
            page: () => observable(1),
        },
        joints: {
            search: ({ query, collection, page }) => {
                watch(_.debounce(() => {
                    if (query.$value) {
                        Nasa.api.images.search(query.$value, page.$value).then(data => {
                            collection.$value = data.collection;
                        });
                    }
                    else {
                        collection.$value = null;
                    }
                }, 600), [query]);
            }
        }
    };
};
